export default __webpack_public_path__ + "static/media/lp-sec02_catch.1eefd280.png";